<template lang="pug">
  .module__main
    .module-content__container(v-loading="isLoading")
      .rate-pairs__container
        .rate-pair__container(v-for="(rates, pair) in rates" :key="`rate-pair-${pair}`")
          .rate-pair__title {{ pair }}
          .rate-pair-rate__container(
            v-for="rate in rates"
            :class="{ selected: rate.isSelectedSource }"
            :key="`rate-pair-${pair}-source-${rate.source}`"
          )
            .rate-source__title {{ rate.source }}
            .rate-source__value
              span.rate-source-value__title Курс:
              span {{ rate.value }}
            .rate-source__value
              span.rate-source-value__title Обновлено:
              span {{ rate.updatedAt }}
            .rate-source-default
              .rate-pair-selected__badge(v-if="rate.isSelectedSource") Используется
              .rate-pair-select__btn(v-else)
                el-button(size="mini" type="success" @click="startUpdateRateSource(pair, rate.source)") Использовать по умолчанию
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { LOAD_RATES, UPDATE_RATE_SOURCE } from '@/store/const/settings';
import instruments from '@/mixins/instruments';

export default {
  name: 'Rates',
  mixins: [instruments],
  data() {
    return {};
  },
  async mounted() {
    await this.loadRates();
  },
  computed: {
    ...mapGetters(['loading']),
    ...mapGetters('settings', ['rates']),
    isLoading() {
      return this.loading(LOAD_RATES) === 'loading';
    },
  },
  methods: {
    ...mapActions('settings', {
      loadRates: LOAD_RATES,
      updateRateSource: UPDATE_RATE_SOURCE,
    }),
    async startUpdateRateSource(pair, source) {
      this.$confirm(
        `Вы уверены, что хотите установить источник ${source} для курса пары ${pair}?`,
        'Подтверждение',
      ).then(async () => {
        const request = await this.updateRateSource({ pair, source });
        await this.notifyRequestResult({
          request,
          successMessage: `Источник курса для пары ${pair} успешно изменен`,
          methodOnSuccess: this.loadRates,
        })
      }).catch(() => {
        this.$message.info('Изменение источника отменено');
      });
    },
  },
};
</script>
<style scoped>
.rate-pairs__container {
  background-color: #ffffff;
  padding: 4px;
  width: 100%;
  height: 100%;
  display: flex;
  flex-wrap: wrap;
}

.rate-pair__container {
  padding: 4px;
  border: 1px solid #d1cece;
  margin: 0 5px;
  width: 250px;
  min-height: 250px;
  max-height: fit-content;
}

.rate-pair__title {
  text-align: center;
  font-weight: bold;
  margin-bottom: 5px;
}

.rate-pair-rate__container {
  padding: 8px;
  border: 1px solid #dbd7d7;
  background-color: #edeaea;
  border-radius: 4px;
  margin-bottom: 5px;
  font-size: 12px;
}

.rate-pair-rate__container.selected {
  background-color: #cde3cd;
  border: 1px solid #8aaf8a;
}

.rate-source__title {
  font-size: 14px;
  font-style: italic;
  font-weight: bold;
  text-align: center;
  margin-bottom: 5px;
}

.rate-source-value__title {
  font-weight: bold;
  margin-right: 5px;
}

.rate-source-default {
  margin-top: 5px;
  position: relative;
  text-align: center;
}

.rate-pair-selected__badge {
  padding: 4px;
  color: #3f2bd7;
  border: 1px dotted #3f2bd7;
  width: fit-content;
  margin: auto;
}
</style>
